<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      unit="群发"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="100px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
      :show-save-button="$permission.canEdit()"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="群发对象" prop="PersonName">
              <el-link type="primary" :underline="true">选择标签</el-link>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="padding-left:32px;padding-bottom:10px">
              <label style="font-weight:400">群发内容</label>
              <el-tabs v-model="activeName" class="mytabs">
                <el-tab-pane label="图文消息" name="first">
                  <single-pic-upload
                    v-model="data.ProfilePhoto"
                    type="ProfilePhoto"
                    :uploadUrl="uploadUrl"
                  ></single-pic-upload>
                </el-tab-pane>
                <el-tab-pane label="文字消息" name="second">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="data.textarea"
                    maxlength="550"
                    show-word-limit
                    rows="7"
                  >
                  </el-input>
                </el-tab-pane>
                <el-tab-pane label="图片消息" name="third">
                  <single-pic-upload
                    v-model="data.Pic"
                    type="ProfilePhoto"
                    :uploadUrl="uploadUrl"
                  ></single-pic-upload>
                </el-tab-pane>
                <el-tab-pane label="语音消息" name="fourth">
                  <single-pic-upload
                    v-model="data.ProfilePhoto"
                    type="ProfilePhoto"
                    :uploadUrl="uploadUrl"
                  ></single-pic-upload>
                </el-tab-pane>
                <el-tab-pane label="视频消息" name="fifth">
                  <single-pic-upload
                    v-model="data.ProfilePhoto"
                    type="ProfilePhoto"
                    :uploadUrl="uploadUrl"
                  ></single-pic-upload>
                </el-tab-pane>
                <el-tab-pane label="模板消息" name="sixth">
                  <single-pic-upload
                    v-model="data.ProfilePhoto"
                    type="ProfilePhoto"
                    :uploadUrl="uploadUrl"
                  ></single-pic-upload>
                </el-tab-pane>
              </el-tabs>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="padding-left:32px;padding-bottom:10px">
             <label style="font-weight:400; line-height:40px">群发备注</label>
              <el-input v-model="data.ContactPhone" clearable></el-input>
        
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="群发类型" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="0">即时群发</el-radio>
                <el-radio :label="1">定时群发</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  props: {},
  computed: {
    host() {
      return window.location.origin; //获取当前网站的域名，用于上传多图那里
    },
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OpenId: "",
        PersonCode: "",
        State: 0, //写道这里
        QrCode: "",
        ContactPhone: "",
        ProfilePhoto: "",
        NickName: "",
        PersonName: "",
        PersonSex: null,
        PersonIdno: "",
        PersonGradeid: null,
        RegisterTime: this.$commonJs.getNowDatetimeString(),
        IdnoPhoto: "",
      },
      saveState: 0,
      gradeList: [],
      IdnoPhoto: [],

      dialogImageUrl: "",
      dialogVisible: false,
      api: require("@/api/person/personinfo").default,
      api2: require("@/api/person/persongrade").default,
      headers: { Authorization: "Bearer " + this.$commonJs.getCookie("token") }, //传图片时加上token
      isMB: this.$store.state.isMB,
      rules: {
       // PersonName: [{ required: true, message: "会员姓名不能为空" }],
       // PersonSex: [{ required: true, message: "性别不能为空" }],
        //ContactPhone: [
         // { required: true, message: "手机号码不能为空" },
         // { validator: this.$commonJs.validateRules.validPhone },
        //],
        //PersonIdno: [{ validator: this.$commonJs.validateRules.idCard }],

        //  ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
      },

      uploadUrl: "/api/Common/UploadPicture",
       activeName: 'first'
    };
  },
  methods: {
    onCreateOpened(data) {
      this.getOption();
    },
    onEditOpened(data) {
      this.getOption();
      if (data.IdnoPhoto) {
        data.IdnoPhoto.split(",").forEach((e) => {
          this.IdnoPhoto.push({
            url: "/api" + e,
            url2: e,
          });
        });
      }
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.gradeList = res.Data;
        }
      });
    },
    beforePhotoUpload(file) {
      const is500k = file.size / 1024 <= 2048;
      if (!is500k) {
        this.$message.error("照片大小不能超过2M");
      }
      return is500k;
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: "/api" + res.Data, url2: res.Data });
      } else {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error(res.Msg);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileRemove(file, fileList, name) {
      var index = this[name].findIndex((x) => x.url == file.url);
      if (index > -1) {
        this[name].splice(index, 1);
      }
    },
    onExceed() {
      this.$message.error("超过上传数量限制");
    },

    onBeforeSave() {
      var place = "";
      this.IdnoPhoto.forEach((e, index) => {
        place += e.url2;
        if (index < this.IdnoPhoto.length - 1) {
          place += ",";
        }
      });
      this.data.IdnoPhoto = place;
    },
    onClosed() {
      this.gradeList = [];
      this.IdnoPhoto = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs__item:first-child{
  padding: 0 10px !important;
}
.mytabs .el-tabs__item {
  padding: 0 10px !important;
}
.upload-tip {
  transform: translateY(26px);
  margin-left: 10px;
}
</style>
